import React, { useState, useEffect, useRef, useCallback } from 'react';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Form } from '@unform/web';
import PropTypes from 'prop-types';
// importando os services
import api from '~/services/api';
import history from '~/services/history';

// Componentes
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Card from '~/components/Card';
import Load from '~/components/Load';

import { Container, BlockInstrucao } from './styles';

export default function WhatMensagem({ match }) {
  const inputRef = useRef(null);
  const [dado, setDado] = useState([]);
  const [carregar, setCarregar] = useState(false);
  const [loading, setLoading] = useState(true);

  const getDados = useCallback(async () => {
    const { whatsapp_id, id } = match.params;
    const response = await api.get(`/whatsapp/${whatsapp_id}/mensagens/${id}`);

    setDado(response.data);
    setLoading(false);
  }, [match.params]);

  useEffect(() => {
    getDados();
  }, [getDados, match.params]);

  // Buscando os dados da api

  async function handlerSubmit(data, { reset }) {
    try {
      setCarregar(true);
      const { whatsapp_id, id } = match.params;
      inputRef.current.setErrors({});

      const schema = Yup.object().shape({
        mensagem: Yup.string().required('Preencha o campo mensagem'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      await api.put(`/whatsapp/${whatsapp_id}/mensagens/${id}`, {
        mensagem: data.mensagem,
      });

      toast.success('Mensagem editada com sucesso');

      reset();
      history.push(`/mensagem-edit/${whatsapp_id}`);
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao editar mensagem verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  if (loading) {
    return <Load />;
  }

  return (
    <Container>
      <h4>Editar Mensagem</h4>
      <Card>
        <Form
          initialData={dado}
          ref={inputRef}
          onSubmit={handlerSubmit}
          autoComplete="off"
        >
          <Input icon="MdMail" name="mensagem" label="Mensagem" type="text" />
          <Button tamanho="40px" load={carregar}>
            Editar
          </Button>
        </Form>
        <BlockInstrucao>
          <h3>Instruções de variaveis para montar suas mensagens</h3>
          <p>
            <strong>[NAME_USER]</strong> = Nome do atendente
          </p>
          <p>
            <strong>[NAME_CLIENTE]</strong> = Nome do cliente
          </p>
          <p>
            <strong>[NAME_INCORPORADORA]</strong> = Nome da incorporadora
          </p>
          <p>
            <strong>[NAME_PRODUTO]</strong> = Nome do produto
          </p>
        </BlockInstrucao>
      </Card>
    </Container>
  );
}

WhatMensagem.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      whatsapp_id: PropTypes.string,
      id: PropTypes.string,
    }),
  }).isRequired,
};
